import React, { Component } from "react";
import { string, array, func, number } from "prop-types";
import Joyride from "react-joyride";
//import Analytics from "../../../utils/analytics";

import "./walkthrough.css";
class Walkthrough extends Component {
  constructor(props, context) {
    super(props, context);

    this.callback = this.callback.bind(this);
  }

  static propTypes = {
    name: string.isRequired,
    version: number.isRequired,
    steps: array.isRequired,
    onFinishWalkthrough: func.isRequired
  };

  componentDidMount() {
    //const { name, version } = this.props;
    // Analytics.event("Walkthrough", "load", {
    //   name,
    //   version
    // });
  }

  callback(data) {
    const { name, version, onFinishWalkthrough } = this.props;

    const actionsToLog = ["next", "click", "back", "skip", "close"];
    if (
      actionsToLog.indexOf(data.action) >= 0 &&
      data.type.indexOf(":before") < 0
    )
      // Analytics.event("Walkthrough", "click", {
      //   name,
      //   version,
      //   joyrideAction: data.action,
      //   joyrideIndex: data.index,
      //   joyrideType: data.type
      // });

    if (data.type === "finished" || data.action === "close") {
			onFinishWalkthrough(name, version);
		}
  }

  render() {
    const { name, steps } = this.props;
    return (
      <div className="cp-walkthrough">
        <Joyride
          ref={name}
          callback={this.callback}
          debug={false}
          locale={{
            back: <span>Back</span>,
            close: <span>Close</span>,
            last: <span>Finish</span>,
            next: <span>Next</span>,
            skip: <span>Skip</span>
          }}
          autoStart={true}
          run={true}
          showOverlay={true}
          showSkipButton={false}
          showStepsProgress={true}
          //stepIndex={this.props.walkthrough.stepIndex}
          steps={steps}
          type={"continuous"}
        />
      </div>
    );
  }
}

export default Walkthrough;



// WEBPACK FOOTER //
// ./src/views/components/walkthrough/Walkthrough.jsx